var _path, _path2, _path3, _rect, _rect2, _path4, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 53,
    viewBox: "0 0 80 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.1287 0C77.6169 4.36644e-07 79.6341 2.02742 79.6344 4.5279V39.7654C79.6344 42.2661 77.6171 44.2933 75.1287 44.2933H4.87136C2.38295 44.2933 0.365692 42.2661 0.365692 39.7654V4.5279C0.36594 2.02742 2.3831 1.15938e-07 4.87136 0H75.1287ZM32.6563 5.116C31.4121 5.116 30.4035 6.1296 30.4035 7.37995C30.4035 8.6303 31.4121 9.6439 32.6563 9.6439H47.6752C48.9194 9.6439 49.928 8.6303 49.928 7.37995C49.928 6.1296 48.9194 5.116 47.6752 5.116H32.6563Z",
    fill: "#E6E7EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5194 12.4826C21.5194 16.141 19.4778 18.7526 16.9594 18.7526C14.441 18.7526 12.3994 16.141 12.3994 12.4826C12.3994 8.8242 13.5394 6.78262 16.9594 6.78262C20.3794 6.78262 21.5194 8.8242 21.5194 12.4826Z",
    fill: "#F9009E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0849 24.6875C27.383 25.5271 26.6407 26.2691 25.7498 26.2691C23.9269 26.2691 20.7343 26.2691 17.1005 26.2691C13.4668 26.2691 10.2742 26.2691 8.45132 26.2691C7.56037 26.2691 6.81808 25.5271 7.11621 24.6875C8.18679 21.6725 12.2507 19.4291 17.1005 19.4291C21.9504 19.4291 26.0143 21.6725 27.0849 24.6875Z",
    fill: "#F9009E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41.9767,
    y: 18.5564,
    width: 32.8629,
    height: 32.8629,
    rx: 16.4315,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41.9767,
    y: 18.5564,
    width: 32.8629,
    height: 32.8629,
    rx: 16.4315,
    stroke: "#C1C5CF",
    strokeWidth: 0.93894
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3075 34.281H52.9391C52.0821 34.281 51.3881 33.6777 51.3881 32.9327V29.8657C51.3881 29.1207 52.0821 28.5173 52.9391 28.5173H65.4281V31.3999H68.5487C68.5487 29.9026 67.8512 28.5454 66.7211 27.5643C65.591 26.5818 64.0333 25.9755 62.3092 25.9755L51.3338 25.974C51.12 25.974 50.9469 26.1245 50.9469 26.3104V27.9656C50.9469 28.1515 50.7738 28.3019 50.5583 28.3019H48.6561C48.4423 28.3019 48.2675 28.4524 48.2675 28.6383V34.1557C48.2675 34.3415 48.4406 34.4935 48.6561 34.4935H50.56C50.7738 34.4935 50.9486 34.644 50.9486 34.8298V36.485C50.9486 36.6709 51.1217 36.8214 51.3355 36.8214H65.4281V41.2368C65.4281 41.9817 64.7341 42.5851 63.8771 42.5851H51.3864V39.704H48.2675C48.2675 41.2014 48.965 42.5586 50.0951 43.5396C51.2252 44.5221 52.7829 45.1284 54.507 45.1284H65.479C65.6928 45.1284 65.8659 44.9779 65.8659 44.7921V43.1369C65.8659 42.951 66.039 42.799 66.2528 42.799H68.1567C68.3705 42.799 68.5453 42.6486 68.5453 42.4627V39.704C68.5453 38.2066 67.8479 36.8494 66.7177 35.8684C65.5876 34.8859 64.0299 34.2796 62.3058 34.2796L62.3075 34.281Z",
    fill: "#00123A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.84055,
    y: 30.1449,
    width: 28.6377,
    height: 1.50725,
    rx: 0.753623,
    fill: "#00123A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.84055,
    y: 33.1594,
    width: 15.8261,
    height: 1.50725,
    rx: 0.753623,
    fill: "#00123A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.84055,
    y: 36.1739,
    width: 23.3623,
    height: 1.50725,
    rx: 0.753623,
    fill: "#00123A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdColored);
export default __webpack_public_path__ + "static/media/IdColored.26b49aae775ac0386c0c8e3d2ee830b1.svg";
export { ForwardRef as ReactComponent };